import React from "react";
import { Col, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { useProgectsDomainByIdQuery } from "../../../../graphql/projects.hooks";
import useGetUrlLocale from "../../../../hooks/useGetUrlLocale";
import AddDomainSteps from "./AddDomainSteps";

export default function AddDomain() {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const { id } = useParams();

  const { data, loading } = useProgectsDomainByIdQuery({
    variables: { domainId: Number(id) },
  });

  return (
    <div className="px-lg-3">
      <h1 className="fs-1 fw-bold">{t("projects.Add Domain")}</h1>
      <div className="text-gray mb-4 mb-md-5">
        <Link to={`${lng}/projects`}>{t("payment.Projects")}</Link>
        <span className="px-2">/</span>
        {loading ? (
          <Spinner
            animation="border"
            role="status"
            size="sm"
            className="ms-2"
          />
        ) : (
          <Link to={`${lng}/projects/${id}`}>{data.domain?.title}</Link>
        )}
        <span className="px-2">/</span>
        <Link to={`${lng}/projects/${id}/edit`}>
          {t("projects.Project Settings")}
        </Link>
        <span className="px-2">/</span>
        {t("projects.Add Domain")}
      </div>

      <div className="text-dark bg-white p-3 py-4 p-md-5 rounded">
        <Col lg={11} className="m-auto px-lg-4">
          {loading ? (
            <div className="text-center my-5 py-5">
              <Spinner animation="border" role="status" />
            </div>
          ) : (
            <AddDomainSteps />
          )}
        </Col>
      </div>
    </div>
  );
}
